import { Component,  Input, EventEmitter, Output } from '@angular/core';
import { HEIGHTS } from '../../../../src/app/helpers/helpers';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'toggle-button',
    imports: [CommonModule, IconComponent],
    template: `
<div class="button" (click)="clickButton($event)" [ngStyle]="{height: height}" [ngClass]="{selected: selected, enabled: enabled, canHover: canHover }">
  <div class="content">
    <ng-content></ng-content>
  </div>
  <div style="flex:1"></div>
  <div class="tick-holder">
    <icon *ngIf="selected" icon="TICK24"></icon>
  </div>
</div>
`,
    styleUrls: ['./toggle-button-wrapper.sass'],
    standalone: true,
})

export class ToggleButtonWrapperComponent {
  @Input() height = HEIGHTS.fifty
  @Input() selected = false
  @Input() canHover = true
  @Input() enabled = true
  @Output() select: EventEmitter<void> = new EventEmitter();


  clickButton(event) {
    event.stopPropagation()
    this.select.emit()
  }

}
